import { inject, Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalUserMessageComponent } from './modal-user-message/modal-user-message.component';
import { NotificationModalComponent } from './notification-modal/notification-modal.component';
@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private readonly modalService = inject(NgbModal);

  openWarningUser(inputs: any): Promise<any> {
    const modalRef = this.modalService.open(ModalUserMessageComponent, {
      windowClass: 'blue-modal',
      centered: true,
      size: 'lg',
    });
    modalRef.componentInstance.title = inputs?.title || `Attenzione`;
    modalRef.componentInstance.message = inputs?.message || `Errore di sistema`;
    modalRef.componentInstance.nextBtn = inputs?.nextBtn || 'Prosegui';
    modalRef.componentInstance.cancelBtn = inputs?.cancelBtn || 'Logout';
    modalRef.componentInstance.classConfirmBtn =
      inputs?.classConfirmBtn || 'btn-primary';
    modalRef.componentInstance.classCancelBtn =
      inputs?.classCancelBtn || 'btn-outline';
    return modalRef.result;
  }


  openNotification({title, message}): Promise<any> {
    const modalRef = this.modalService.open(NotificationModalComponent, {
      windowClass: 'blue-modal',
      centered: true,
      size: 'sm',
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    return modalRef.result;
  }
}
